import { jsx } from "react/jsx-runtime";
import { cx, css } from "@/styled-system/css";
import { Alert } from "@zillow/constellation-10";
const errorBoxBaseStyles = css({
  marginInline: "auto"
});
const errorBoxWithTopMargin = css({
  marginBlockStart: "default"
});
const ErrorBox = ({
  errorMessage,
  hideTopMargin = false
}) => /* @__PURE__ */ jsx("div", { "data-testid": "error-message", className: cx(errorBoxBaseStyles, !hideTopMargin && errorBoxWithTopMargin), children: /* @__PURE__ */ jsx(Alert, { tone: "critical", children: errorMessage }) });
export {
  ErrorBox as default
};
